import { h, ref } from 'vue';
import DateField from '@/components/input/DateField.vue';
import { DatePickerService } from '@/corePagesModule/service/datepickerService';
import { i18n } from '@/i18n';
import { createModalActionResult } from '@/corePagesModule/components/modal/modalActions';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import { RemindDateInfo } from '@/remindModule/entities/reminder';

const t = i18n.t;

/**
 * InfoModalとDatePickerを用いてリマインドする年月日を入力させる
 * @param remindDate - リマインドメールを送信する年月日情報
 * @param titleValue - カスタムモーダルタイトル
 * @returns モーダルの選択結果 {カレンダーの選択日時, モーダルの選択結果}を返す
 */
export const openRemindDateModal = async (remindDate: Date, titleValue = t('発注のリマインド設定')): Promise<RemindDateInfo> => {
  const selectedDate = ref(new Date(remindDate));
  const disabledDates = DatePickerService.getFuncValidateCalendarDatesToNextDay(remindDate);

  const result = await showInfoModal({
    modalTitle: titleValue,
    modalDescription: t('発注リマインドモーダルテキスト'),
    // eslint-disable-next-line jsdoc/require-jsdoc
    modalContent: () =>
      h('div', { class: 'remind-date-modal' }, [
        h(DateField, {
          'input-date': selectedDate.value,
          'is-modal': true,
          'disabled-dates': disabledDates,
          /**
           * モーダル内で選択された日時を保持
           * @param date - DateFieldから渡される新しい日付
           */
          onChangeValue: (date: Date) => {
            selectedDate.value = date;
          },
        }),
      ]),
    backButtonLabel: t('スキップ'),
    nextButtonLabel: t('設定'),
    icon: 'info',
    enableOutsideClick: false,
    testId: 'remind_date_modal_container',
    useKeyboard: true,
  });
  const resultObj: RemindDateInfo = {
    date: selectedDate.value,
    result: result ? createModalActionResult('confirm') : createModalActionResult('deny'),
  };
  return resultObj;
};
